import React from 'react';

import { Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';

export type AdminEventCheckItemProps = {
  label: string;
  value: string;
  showStatus: boolean;
  isOk: boolean;
};

const Item = ({ label, value, showStatus, isOk }: AdminEventCheckItemProps) => (
  <div
    style={{
      display: 'flex',
      gap: showStatus ? '2px' : '6px',
      alignItems: 'center',
      marginBottom: '5px',
    }}
  >
    <Typography variant="body2">{label}:</Typography>
    {showStatus && (isOk ? <CheckIcon fontSize="small" style={{ color: '#20B000' }} /> : <CloseIcon fontSize="small" color="error" />)}
    <Typography variant="body2" color="textSecondary" noWrap>
      {value}
    </Typography>
  </div>
);

export type AdminEventCheckProps = {
  items: AdminEventCheckItemProps[];
};

/**
 * Displays a list of checkable list items
 */
const AdminEventCheck = ({ items }: AdminEventCheckProps) => (
  <>
    {items.map((item) => (
      <div key={`admin--event--check--${item.label}`}>
        <Item label={item.label} value={item.value} showStatus={item.showStatus} isOk={item.isOk} />
      </div>
    ))}
  </>
);

export default AdminEventCheck;
